export default __webpack_public_path__ + "b9d7e9ade9ba8774f06e6e4abeb4f724.png";